import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import CheckOnIcon from '@material-ui/icons/CheckCircle';
import CheckIcon from '@material-ui/icons/CheckCircleOutline';
// import SvgIcon from '@material-ui/core/SvgIcon';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
// import Popover from '@material-ui/core/Popover';
import Paper from '@material-ui/core/Paper';

// src/
import originalDesignImage from '../asets/originalDesign.png';
// import MySelect from '../components/MySelect'
import { selectOptions } from '../actions/options';

const tile = {
  width: 200
};

const styles = theme => ({
  selectRoot: {
    margin: 0,
    background: '#fff',
    '&:hover': {
      color: '#40a9ff'
    },
    '&:hover svg': {
      color: '#40a9ff'
    },
    fontSize: '12px'
  },
  selectUnderline: {
    width: '100%',
    minWidth: '250px',
    borderBottom: 'none',
    '&:after': {
      borderBottom: 'solid 2px #40a9ff'
      // borderBottom: "none",
    }
  },
  MenuItem: {
    height: 'auto'
  },
  hoverSwitch: {
    position: 'relative',
    '&:hover >.hoverPop': {
      display: 'block'
    }
  },
  hoverPop: {
    backgroundColor: '#ccc',
    padding: theme.spacing.unit,
    boxShadow:
      '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)'
  },
  appBar: {
    position: 'relative',
    // backgroundColor: '#c7000b',
    backgroundColor: '#999'
  },
  flex: {
    flex: 1
  },
  page: {
    display: 'flex',
    flexWrap: 'wrap',
    height: '100%',
    backgroundColor: '#eee'
  },
  colRight: {
    width: 500,
    // position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '& >img': {
      display: 'block',
      width: 'auto',
      height: 'auto',
      maxWidth: 500,
      maxHeight: 500,
      boxShadow: '1px 1px 3px #999'
      // position: 'absolute',
      // top: '50%',
      // left: '50%',
      // transform: 'translate(-50%, -50%)',
    }
  },
  previewTitle: {
    marginTop: 10,
    fontWeight: 'bold'
  },
  note: {
    width: 450,
    marginTop: 30
  },
  colLeft: {
    width: 'calc(100% - 500px)',
    display: 'flex',
    // justifyContent: 'space-around',
    overflow: 'auto',
    backgroundColor: '#fff'
  },
  colLeftInner: {
    // position:'relative',
    // height: "100%",
    // flexWrap: 'nowrap',
    // float: 'left',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  tile: {
    // float:'left',
    // display: 'flex',
    // position:'relative',
    width: tile.width,
    height: tile.width + 40,
    margin: '0 1px'
  },
  thumbnailBox: {
    position: 'relative',
    width: tile.width,
    height: tile.width
  },
  thumbnail: {
    display: 'block',
    width: 'auto',
    height: 'auto',
    maxWidth: tile.width - 20,
    maxHeight: tile.width - 20,
    boxShadow: '1px 1px 3px #999',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer'
  },
  iconButton: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    cursor: 'pointer'
  },
  iconSelected: {
    color: '#0c3'
  },
  iconNonSelected: {
    color: '#666'
  },
  thumbnailTitle: {
    padding: '5px 7px',
    // backgroundColor:'#333',
    color: '#666',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'center'
  }
});

const emptyData = {
  id: 0,
  title: 'オリジナルデザイン制作',
  img: originalDesignImage
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class DialogDesignTemplate extends React.Component {
  state = {
    open: false,
    selected: emptyData,
    preview: emptyData
  };
  componentWillReceiveProps(nextProps) {
    const { defaultValue, templates } = nextProps;
    // const { templates } = this.props;
    let selected = emptyData;
    for (let i = 0; i < templates.length; i++) {
      if (templates[i].id === defaultValue + '') {
        selected = templates[i];
      }
    }
    this.setState({
      selected: selected,
      preview: selected
    });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClickThumbnail = e => {
    this.setState({
      preview: {
        // id: e.target.dataId,
        title: e.target.alt,
        img: e.target.src
      }
    });
  };
  handleClickCheckIcon = tile => {
    this.setState({
      selected: {
        id: tile.id,
        title: tile.title,
        img: tile.img
      },
      preview: {
        id: tile.id,
        title: tile.title,
        img: tile.img
      },
      open: false
    });
    this.props.selectOptions({
      requestDesignTemplateId: tile.id,
      requestDesignTypeId: tile.id > 0 ? 1 : 0
    });
  };

  render() {
    const { classes, templates } = this.props;
    const tileData = [emptyData, ...templates];

    return (
      <div className={classes.hoverSwitch}>
        <Select
          classes={{ root: classes.selectRoot, icon: classes.selectIcon }}
          open={false}
          onOpen={() => {}}
          onClose={() => {}}
          onClick={this.handleClickOpen}
          value={this.state.selected.id}
          input={
            <Input
              classes={{
                root: classes.selectInput,
                underline: classes.selectUnderline
              }}
            />
          }
        >
          <MenuItem className={classes.MenuItem} value={this.state.selected.id}>
            {this.state.selected.title}
          </MenuItem>
        </Select>
        <div className="hoverPop">
          <Paper className={classes.hoverPop} elevation={1}>
            <img
              src={this.state.selected.img}
              alt={this.state.selected.title}
            />
          </Paper>
        </div>
        {/* <div className="imgBox">
                    <img src={this.state.selected.img} alt={this.state.selected.title} />
                </div> */}
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={this.handleClose}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="title"
                color="inherit"
                className={classes.flex}
              >
                無料デザイン（※オリジナルは有料）がセット（必須）ですので、下記のテンプレートから選択してください。
                <br />
                データがある場合は
                <a
                  href={`${
                    process.env.REACT_APP_SITE_URL
                  }products/detail_pack.html`}
                  style={{ color: '#c00' }}
                >
                  チラシ印刷＋ポスティング
                </a>
                から注文してください。
              </Typography>
            </Toolbar>
          </AppBar>
          <div className={classes.page}>
            <div className={classes.colLeft}>
              <div className={classes.colLeftInner}>
                {tileData.map((tile, key) => (
                  <div key={key} className={classes.tile}>
                    <div className={classes.thumbnailBox}>
                      <img
                        className={classes.thumbnail}
                        data-id={tile.id}
                        src={tile.img}
                        alt={tile.title}
                        onClick={this.handleClickThumbnail}
                        onMouseOver={this.handleClickThumbnail}
                      />
                      <IconButton
                        className={classes.iconButton}
                        onClick={() => {
                          this.handleClickCheckIcon(tile);
                        }}
                      >
                        {tile.id === this.state.selected.id ? (
                          <CheckOnIcon className={classes.iconSelected} />
                        ) : (
                          <CheckIcon className={classes.iconNonSelected} />
                        )}
                      </IconButton>
                    </div>

                    <div className={classes.thumbnailTitle}>{tile.title}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.colRight}>
              <img src={this.state.preview.img} alt="sample" />
              <div className={classes.previewTitle}>
                {this.state.preview.title}
              </div>
              <div className={classes.note}>
                ※デザインのご依頼や求人の原稿内容によっては、別途制作期間がかかりますので納期ズレが生じます。
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

DialogDesignTemplate.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  defaultValue: state.options.selected.requestDesignTemplateId,
  templates: state.options.requestDesignTemplate
});

const mapDispatchToProps = dispatch => ({
  selectOptions: selected => dispatch(selectOptions(selected))
});

// export default withStyles(styles)(DialogDesignTemplate);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(DialogDesignTemplate));



// WEBPACK FOOTER //
// ./src/components/DialogDesignTemplate.js